import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.object.keys";
import _defineProperty from "/data/landun/workspace/vft-activities/d2d-welfare/codebase/node_modules/@babel/runtime-corejs2/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import Vue from 'vue';
import reportPlugin from '@tencent/vft-report-sdk';
import { store } from "../store/index";
var normalBossConfig = {
  // pvBoss: { bossId: 6183, pwd: 1714812455 },
  // eventBoss: { bossId: 6183, pwd: 1714812455 },
  pvBoss: {
    attaId: 'z0600006183',
    token: 4638848787
  },
  eventBoss: {
    attaId: 'z0600006183',
    token: 4638848787
  }
};
var actBossConfig = {
  // pvBoss: { bossId: 5380, pwd: 895678138 },
  // eventBoss: { bossId: 5380, pwd: 895678138 },
  pvBoss: {
    attaId: 'z7100005380',
    token: 895678138
  },
  eventBoss: {
    attaId: 'z7100005380',
    token: 3515926467
  }
};
export function setup() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref$use = _ref.use,
      use = _ref$use === void 0 ? true : _ref$use,
      _ref$reportData = _ref.reportData,
      reportData = _ref$reportData === void 0 ? {} : _ref$reportData,
      _ref$pageType = _ref.pageType,
      pageType = _ref$pageType === void 0 ? 'normal' : _ref$pageType,
      _ref$extraParams = _ref.extraParams,
      extraParams = _ref$extraParams === void 0 ? {} : _ref$extraParams;

  if (use) {
    Vue.use(reportPlugin, {
      reportData: reportData,
      reporterArr: [new reportPlugin.BossReport(_objectSpread(_objectSpread({}, pageType === 'normal' ? normalBossConfig : actBossConfig), {}, {
        presetParam: function presetParam() {
          var param = reportPlugin.BossReport.getPresetParam();
          return Object.assign(param, extraParams, {
            f_vip: store.state.payVip ? store.state.payVip.vip : -1,
            f_level: store.state.payVip ? store.state.payVip.level : 0
          }); // 上报基础参数中需要包含会员身份信息，所以上报需要在获取会员身份信息后再启动
        },
        delay: true
      }))]
    });
    store.state.initPromise.then(function () {
      Vue.prototype.$reportReady();
    });
  }
}